import { render, staticRenderFns } from "./CardTarjaEnqueteF1Globo.vue?vue&type=template&id=3ce49622&scoped=true"
import script from "./CardTarjaEnqueteF1Globo.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteF1Globo.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteF1Globo.vue?vue&type=style&index=0&id=3ce49622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce49622",
  null
  
)

export default component.exports